import React from 'react';
import ProfileShell from '../../components/forms/ProfileShell';
import { SectionHeader, Field, Input, Select, Toggle, TextArea } from '../../components/forms/FormPrimitives';

const COVERAGE_NEEDS = [
  { key: 'need_gl', label: 'General Liability' },
  { key: 'need_workers_comp', label: 'Workers Compensation' },
  { key: 'need_property', label: 'Commercial Property' },
  { key: 'need_auto', label: 'Business Auto' },
  { key: 'need_professional', label: 'Professional Liability (E&O)' },
  { key: 'need_cyber', label: 'Cyber Liability' },
];

const BusinessProfile = () => {
  const sections = [
    {
      title: 'Business Basics',
      render: (data, update) => (
        <div>
          <SectionHeader index={1} title="Business Basics" subtitle="The essentials about your business." />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Business Name" testid="biz-name">
              <Input value={data.business_name} onChange={(v) => update({ business_name: v })} placeholder="ABC Corp" />
            </Field>
            <Field label="Contact Name" testid="biz-contact">
              <Input value={data.contact_name} onChange={(v) => update({ contact_name: v })} placeholder="Your name" />
            </Field>
            <Field label="Phone" testid="biz-phone">
              <Input type="tel" value={data.phone} onChange={(v) => update({ phone: v })} placeholder="(555) 123-4567" />
            </Field>
            <Field label="Email" testid="biz-email">
              <Input type="email" value={data.email} onChange={(v) => update({ email: v })} placeholder="you@example.com" />
            </Field>
            <Field label="Business Type" testid="biz-type">
              <Input value={data.business_type} onChange={(v) => update({ business_type: v })} placeholder="e.g. Landscaping" />
            </Field>
            <Field label="Years in Business" testid="biz-years">
              <Input value={data.years_in_business} onChange={(v) => update({ years_in_business: v })} placeholder="5" />
            </Field>
            <Field label="City" testid="biz-city">
              <Input value={data.city} onChange={(v) => update({ city: v })} placeholder="Dallas" />
            </Field>
            <Field label="ZIP" testid="biz-zip">
              <Input value={data.zip_code} onChange={(v) => update({ zip_code: v })} placeholder="75001" />
            </Field>
          </div>
        </div>
      ),
    },
    {
      title: 'Business Operations',
      render: (data, update) => (
        <div>
          <SectionHeader index={2} title="Business Operations" subtitle="Help us understand your operation size and scope." />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Number of Employees" testid="biz-employees">
              <Input value={data.num_employees} onChange={(v) => update({ num_employees: v })} placeholder="12" />
            </Field>
            <Field label="Annual Revenue" testid="biz-revenue">
              <Input value={data.annual_revenue} onChange={(v) => update({ annual_revenue: v })} placeholder="$500,000" />
            </Field>
          </div>
          <Field label="Business Address" testid="biz-address">
            <Input value={data.business_address} onChange={(v) => update({ business_address: v })} placeholder="123 Main St, Dallas, TX" />
          </Field>
          <Field label="Services Provided" testid="biz-services">
            <TextArea value={data.services_provided} onChange={(v) => update({ services_provided: v })} placeholder="Brief description of what you offer" />
          </Field>
        </div>
      ),
    },
    {
      title: 'Current Insurance',
      render: (data, update) => (
        <div>
          <SectionHeader index={3} title="Current Insurance" subtitle="If you have a current policy, share what you know." />
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Current Carrier" testid="biz-carrier">
              <Input value={data.current_carrier} onChange={(v) => update({ current_carrier: v })} placeholder="e.g. The Hartford" />
            </Field>
            <Field label="Current Limits" testid="biz-limits">
              <Input value={data.current_limits} onChange={(v) => update({ current_limits: v })} placeholder="e.g. $1M / $2M" />
            </Field>
          </div>
          <Field label="Claims History" testid="biz-claims">
            <TextArea value={data.claims_history} onChange={(v) => update({ claims_history: v })} placeholder="Any claims in the past 5 years? Brief description." />
          </Field>
        </div>
      ),
    },
    {
      title: 'Coverage Needs',
      render: (data, update) => (
        <div>
          <SectionHeader index={4} title="Coverage Needs" subtitle="Select what you're interested in reviewing." />
          <div className="space-y-3">
            {COVERAGE_NEEDS.map((c) => (
              <Toggle
                key={c.key}
                value={data[c.key]}
                onChange={(v) => update({ [c.key]: v })}
                label={c.label}
                testid={`biz-${c.key}`}
              />
            ))}
          </div>
          <Field label="Anything else we should know?" testid="biz-notes">
            <TextArea value={data.profile_notes} onChange={(v) => update({ profile_notes: v })} placeholder="Optional notes about your business" />
          </Field>
        </div>
      ),
    },
  ];

  return (
    <ProfileShell
      coverageType="business"
      sections={sections}
      personalTouchMessage="Every business is different. Complete what you can — we'll help review coverage options that fit your operation, risks, and budget."
    />
  );
};

export default BusinessProfile;
